import { render } from "./HandleRooms.vue?vue&type=template&id=2c66ae6a"
import script from "./HandleRooms.vue?vue&type=script&lang=js"
export * from "./HandleRooms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__